import { Tooltip } from '@mui/material'
import cn from 'classnames'
import React from 'react'
import config from '../../config.json'
import CollectionTitle from './CollectionTitle'
import { useTranslation } from 'react-i18next'

export const AssetTitle = ({ asset }) => {
    let { name, collection, burned } = asset

    const { t } = useTranslation('common')

    return (
        <div
            className={cn(
                'border dark:!bg-paper bg-white rounded-md shadow-xl',
                'dark:!border-paperl border-zinc-200 p-4 ml-0 lg:ml-4 mt-4 w-auto',
            )}
        >
            <div className="pb-2 lg:pb-4 text-xl lg:text-2xl xl:text-4xl flex">
                {name}{' '}
                {burned && (
                    <Tooltip title={t('asset.burned_asset')}>
                        <img className={'ml-4 h-10'} src={'/fire.png'} />
                    </Tooltip>
                )}
            </div>

            <CollectionTitle
                collectionName={collection.collectionName}
                displayName={collection.displayName}
                collectionImage={collection.collectionImage}
                collectionThumbnail={config.ipfspreviewhash
                    .replace('{collection}', collection.collectionName)
                    .replace('{hash}', collection.collectionImage)
                    .replace('{size}', '80')}
                verified={collection.verification}
            />
        </div>
    )
}
